
<div class="popup-container" mat-dialog-content>

    <!--=============================================-->
    <!-- Simple Popups - Definition in Dictionary -->
    <!--=============================================-->

    <div *ngIf="DictionaryObject as obj">
        <h4>{{obj.Header}}</h4>
        <p [innerHtml]="obj.Body"></p>
    </div>


    <!--=============================================-->
    <!-- Custom popups that require special HTML -->
    <!--=============================================-->

    <ng-container *ngIf="!DictionaryObject">

    </ng-container>

</div>

<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Close</button>
</div>

<div class="Vert-15"></div>

